import { createCRUDHook } from './createCRUDHook';
import { CustomerOrderOtherLinkDto } from 'utils/models';
import { TBL_CUSTOMER_ORDER_OTHER_LINK } from './apiEndPoints';

// Create the CRUD hook - that's it!
const { Context, useManager, useConsumer } =
  createCRUDHook<CustomerOrderOtherLinkDto>({
    entityName: 'CustomerOtherLink',
    endpoint: TBL_CUSTOMER_ORDER_OTHER_LINK,
  });

export const CustomerOrderOtherLinkContext = Context;
export const useCustomerOtherLinkManager = useManager;
export const useCustomerOtherLink = useConsumer;
